<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-user text-white text-4xl"></i>
      </div>
    </div>
    <div class="px-6 text-center">
      <h2 class="text-2xl font-bold mb-2 mt-2">Sei nuovo da queste parti!</h2>
      <p class="text-gray-500 mb-6">È necessario completare il profilo prima di poter inviare la tua candidatura</p>
      <CuButton primary class="w-full mt-auto" @click="$emit('start')">
        
        Iniziamo
        <i class="bx bx-chevron-right text-2xl"></i>
      </CuButton>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "NewUserOnboardingSheet",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false }
  }
}
</script>
